import Option from 'react-select/lib/Option.js';
import React from 'react';

export default class OptionOverride extends Option {
  render() {
    if (this.props.option && this.props.option.hidden) {
      return <div />;
    }
    return super.render();
  }
}
